import * as React from 'react';
import { Paper } from '@mui/material';
import { Box } from '@mui/system';
import classes from './StatCard.module.css';
var StatCard = function (_a) {
    var width = _a.width, height = _a.height, children = _a.children;
    return (React.createElement(Box, { className: classes.box, sx: {
            display: 'flex',
            '& > :not(style)': {
                m: 4,
                maxWidth: { width: width },
                maxHeight: { height: height },
                borderRadius: 3,
            },
        } },
        React.createElement(Paper, { elevation: 16, sx: {
                display: 'flex',
                justifyContent: 'space-around',
                backgroundColor: 'white',
                opacity: 0.8,
            } }, children)));
};
export default StatCard;
